import React, { useEffect } from 'react';
import { Alert, Button, Space, Typography } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';

const { Text, Paragraph, Title } = Typography;

const ESignRedirect = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const signUrl = location.state?.signUrl;
  const returnTo = location.state?.returnTo || '/billing/create';

  useEffect(() => {
    if (!signUrl) return;
    // Redirect in the same tab as requested
    window.location.assign(signUrl);
  }, [signUrl]);

  if (!signUrl) {
    return (
      <div className="container-fluid px-3 py-4">
        <Alert
          showIcon
          type="error"
          message="Signing link is unavailable"
          description="Return to the bill and start eSign again."
          action={
            <Button type="primary" size="small" onClick={() => navigate(returnTo)}>
              Back to Bill
            </Button>
          }
        />
      </div>
    );
  }

  return (
    <div className="container-fluid px-3 py-4" style={{ maxWidth: 720, margin: 'auto' }}>
      <Title level={4} style={{ marginBottom: 8 }}>Opening signing page</Title>
      <Paragraph type="secondary" style={{ marginBottom: 16 }}>
        We are opening the signing page in this tab. If it does not open automatically, use the button below.
      </Paragraph>
      <Space direction="vertical" size="large" style={{ width: '100%' }}>
        <Button type="primary" block onClick={() => window.location.assign(signUrl)}>
          Continue to Signing
        </Button>
        <Button block onClick={() => navigate(returnTo)}>
          Back to Bill
        </Button>
        <Text type="secondary">Request: {location.state?.requestId || 'N/A'}</Text>
      </Space>
    </div>
  );
};

export default ESignRedirect;
